import { useQuery } from '@tanstack/react-query';
import { dataService, AlertStats } from '../services/data';

export function useAlertStats() {
  return useQuery<AlertStats, Error>({
    queryKey: ['alertStats'],
    queryFn: () => dataService.getAlertStats(),
    refetchInterval: 30000, // Refresh every 30 seconds
    refetchIntervalInBackground: false, // Don't refresh when tab is not active
  });
}
